import { render, staticRenderFns } from "./DoctorProfileDropDown.vue?vue&type=template&id=36919275&scoped=true&"
import script from "./DoctorProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./DoctorProfileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./DoctorProfileDropDown.vue?vue&type=style&index=0&id=36919275&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36919275",
  null
  
)

export default component.exports